var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafetyCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 72 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_206326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5819 82.8168C35.5819 82.8168 67.0832 67.0661 67.0832 43.4401V15.8765L35.5819 4.06348L4.08057 15.8765V43.4401C4.08057 67.0661 35.5819 82.8168 35.5819 82.8168Z",
    stroke: "currentColor",
    strokeWidth: 7.2045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1961 66.2093C37.8225 66.5865 37.4489 66.9637 37.0753 66.9637C36.328 67.3409 35.2072 67.3409 34.0863 66.9637C33.7127 66.5865 33.3391 66.5865 32.9654 66.2093L18.0205 51.1213C16.526 49.6125 16.526 47.3493 18.0205 45.8405C19.515 44.3317 21.7568 44.3317 23.2512 45.8405L31.8446 54.5161V23.3989C31.8446 21.1357 33.3391 19.6269 35.5808 19.6269C37.8225 19.6269 39.317 21.1357 39.317 23.3989V54.5161L47.9103 45.8405C48.6576 45.0861 49.7784 44.7089 50.5257 44.7089C51.2729 44.7089 52.3938 45.0861 53.141 45.8405C54.6355 47.3493 54.6355 49.6125 53.141 51.1213L38.1961 66.2093Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_206326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.878,
    height: 86.6286,
    fill: "white",
    transform: "translate(0.142822 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyCheckIn);
export default __webpack_public_path__ + "static/media/safety-check-in.926c8c97dad9124a8d3c31520e14ccae.svg";
export { ForwardRef as ReactComponent };